export { default } from './EmpresesSolidariesMarato';
